import { render, staticRenderFns } from "./RoomCBTView.vue?vue&type=template&id=11e4a601&"
import script from "./RoomCBTView.vue?vue&type=script&lang=js&"
export * from "./RoomCBTView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11e4a601')) {
      api.createRecord('11e4a601', component.options)
    } else {
      api.reload('11e4a601', component.options)
    }
    module.hot.accept("./RoomCBTView.vue?vue&type=template&id=11e4a601&", function () {
      api.rerender('11e4a601', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/CBT/RoomCBTView.vue"
export default component.exports